var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainContent" },
    [
      _c("main-title", {
        attrs: { arrowClick: true },
        scopedSlots: _vm._u([
          {
            key: "rightBtn",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
        ]),
      }),
      _c(_vm.navComponent, { tag: "component" }),
      _c("lengend-bar"),
      _c(_vm.leftComponent, { tag: "component" }),
      _c(_vm.rightComponent !== "video" ? _vm.rightComponent : "videos", {
        tag: "component",
      }),
      _c("hright-side"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }